import createReactComponent from '../createReactComponent';
export default createReactComponent('arrow-long-down', 'ArrowLongDown', [["path",{"d":"m8 18 4 4m0 0 4-4m-4 4V2","key":"svg-0"}]]);